import { Navigate } from "react-router-dom";
import { useAuth } from "@/lib/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <main className="max-w-md mx-auto px-6 py-24 text-center" data-testid="protected-loading">
        <div className="w-10 h-10 border-4 border-orange-200 border-t-orange-500 rounded-full animate-spin mx-auto mb-3" />
        <div className="text-sm text-[var(--ink-soft)]">Verification de la session...</div>
      </main>
    );
  }
  if (!user) return <Navigate to="/connexion" replace />;
  return children;
}
